import { Component, OnInit } from '@angular/core';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-esqueci-minha-senha-alterar',
    templateUrl: './esqueci-minha-senha-alterar.component.html',
    styleUrls: ['./esqueci-minha-senha-alterar.component.css'],
    imports: [CommonModule, ReactiveFormsModule]
})
export class EsqueciMinhaSenhaAlterarComponent implements OnInit {

  public form: FormGroup = null;
  public loading: boolean = false;
  
  public concluido: boolean = false;
  public msgErro: string = null;

  public msgConfNovaSenha: string = null;

  private token: string = null;

  constructor(public autenticacao: AutenticacaoService, private router: Router, private route: ActivatedRoute) { 
    
    this.form = new FormGroup({
      senha: new FormControl(null, [Validators.required, Validators.minLength(8)]),
      senhaConfirmacao: new FormControl(null, [Validators.required, Validators.minLength(8)])
    });

    this.route.params.subscribe(params => {
      
      if(params['token']==''){
        alert('Parâmetro inválido');
        this.router.navigate(['/autenticacao/login']);
      }else{
        this.token = params['token'];
      }

    });
  }

  ngOnInit() {

  }

  validarSenhaConfirmacao(){

    if(this.form.get('senha').value != this.form.get('senhaConfirmacao').value){
      this.msgConfNovaSenha = "As senhas não conferrem";
      this.form.controls['senhaConfirmacao'].setErrors({'incorrect': true});
      return;
    }else{
      this.form.controls['senhaConfirmacao'].setErrors(null);
      this.msgConfNovaSenha = null;
    }
  }

  salvar(){

    let senha = this.form.get('senha').value;
    let senhaConfirmacao = this.form.get('senhaConfirmacao').value;

    this.loading = true;
    this.form.disable();

    this.autenticacao
        .esqueciMinhaSenha(this.token, senha, senhaConfirmacao)
        .pipe(
          finalize(() => { 
            this.loading = false;
            this.form.enable();
          })
        )
        .subscribe(
          (res: number) => {

            if(res==1){
              alert("Senha alterada com sucesso !");
              this.router.navigate(['/autenticacao/login']);
            }else{
              alert("Erro ao criar a nova senha");
            }

          },
          (httpError: HttpErrorResponse) => {
            this.msgErro = httpError.error.ex;

            setTimeout(()=> {
              this.msgErro = null;
            }, 8000);
        });
  }
}
